export const HELPDESK_ACTIVATED = "HELPDESK_ACTIVATED";
export const DISMISS_HELPDESK = "DISMISS_HELPDESK";

export const HELPDESK_SERVICE_STARTED = "HELPDESK_SERVICE_STARTED";
export const HELPDESK_SERVICE_SUCCEEDED = "HELPDESK_SERVICE_SUCCEEDED";
export const HELPDESK_SERVICE_FAILED = "HELPDESK_SERVICE_FAILED";
